const Constants = {
    Storage : {
        token : 'token',
        firstname: 'firstname',
        lastname: 'lastname',
        roleid: 'roleid',
        organization: 'organization',
        username: 'username',
        user: 'user',
        filterObj: 'filterObj',
        selectedOrg: 'selectedOrg',
        selectedOrgPrimary: 'selectedOrgPrimary',
        selectedOrgName: 'selectedOrgName',
        shareId: 'shareId',
        shareUserId: 'shareUserId',
        uid: 'uid',
        version: 'version',
        templatename: 'templatename',
        zendeskwidgettoken: 'zendeskwidgettoken',
        zendeskssotoken: 'zendeskssotoken',
        daterange: 'daterange',
        fileData: 'fileData',
        reportData: 'reportData'
    }
};

export default class LocalStorage {
    
    public getToken(): string {
        return localStorage.getItem(Constants.Storage.token) || '';
    }

    public setToken(value: string) {
        localStorage.setItem(Constants.Storage.token, value);
    }

    // Set Current T&C's Version
    public setVersion(value: string) {
        localStorage.setItem(Constants.Storage.version, value);
    }

    // Get Current T&C's Version
    public getVersion(): string {
        return localStorage.getItem(Constants.Storage.version) || '';
    }

    // Set Current T&C's Template Name
    public setTemplateName(value: string) {
        localStorage.setItem(Constants.Storage.templatename, value);
    }

    // Get Current T&C's Template Name
    public getTemplateName(): string {
        return localStorage.getItem(Constants.Storage.templatename) || '';
    }

    public getFirstName(): string {
        return localStorage.getItem(Constants.Storage.firstname) || '';
    }

    public getUserName(): string {
        return localStorage.getItem(Constants.Storage.firstname) || '';
    }

    public setUserName(value: string) {
        localStorage.setItem(Constants.Storage.firstname, value);
    }

    public getSelectedOrg(): string {
        return localStorage.getItem(Constants.Storage.selectedOrg) || '';
    }

    public setSelectedOrg(value: string) {
        localStorage.setItem(Constants.Storage.selectedOrg, value);
    }
    
    public setSelectedOrgPrimary(value: string) {
        localStorage.setItem(Constants.Storage.selectedOrgPrimary, value);
    }

    public getSelectedOrgPrimary(): string {
        return localStorage.getItem(Constants.Storage.selectedOrgPrimary) || '';
    }

    public setUser(value: string) {
        console.log('setuser', value);
        localStorage.setItem(Constants.Storage.user, value);
    }

    public getUser() {
        return localStorage.getItem(Constants.Storage.user) || '';
    }

    public setUid(value: string) {
        console.log('setuser', value);
        localStorage.setItem(Constants.Storage.uid, value);
    }

    public getUid(): string {
        return localStorage.getItem(Constants.Storage.uid) || '';
    }

    public setFirstName(value: string) {
        localStorage.setItem(Constants.Storage.firstname, value);
    }

    public getLastName(): string {
        return localStorage.getItem(Constants.Storage.lastname) || '';
    }

    public setLastName(value: string) {
        localStorage.setItem(Constants.Storage.lastname, value);
    }

    public setDateRange(value: any) {
        localStorage.setItem(Constants.Storage.daterange, value);
    }

    public getDateRange() {
        return localStorage.getItem(Constants.Storage.daterange) || '';
    }

    // public getRoleID(): string {
    //     return localStorage.getItem(Constants.Storage.roleid) || '';
    // }

    // public setRoleID(value: string) {
    //     localStorage.setItem(Constants.Storage.roleid, value);
    // }

    public getOrganizationName(): string {
        return localStorage.getItem(Constants.Storage.organization) || '';
    }

    public setOrganizationName(value: string) {
        localStorage.setItem(Constants.Storage.organization, value);
    }

    public getSelectedOrgName(): string {
        return localStorage.getItem(Constants.Storage.selectedOrgName) || '';
    }

    public setSelectedOrgName(value: string) {
        localStorage.setItem(Constants.Storage.selectedOrgName, value);
    }

    public getUsername(): string {
        return localStorage.getItem(Constants.Storage.username) || '';
    }

    public setUsername(value: string) {
        localStorage.setItem(Constants.Storage.username, value);
    }
    
    public getFilterObj() {
        return localStorage.getItem(Constants.Storage.filterObj) || '{}';
    }

    public setFilterObj(value: string) {
        localStorage.setItem(Constants.Storage.filterObj, value);
    }
    
    public getSharedId(): string {
        return localStorage.getItem(Constants.Storage.shareId) || '';
    }

    public setSharedId(value: string) {
        localStorage.setItem(Constants.Storage.shareId, value);
    }

    public getSharedUserId(): string {
        return localStorage.getItem(Constants.Storage.shareUserId) || '';
    }

    public setSharedUserId(value: string) {
        localStorage.setItem(Constants.Storage.shareUserId, value);
    }

    public getZendeskWidgetToken(): string {
        return localStorage.getItem(Constants.Storage.zendeskwidgettoken) || '';
    }

    public setZendeskWidgetToken(value: string) {
        value = value !== undefined ? value : '';
        localStorage.setItem(Constants.Storage.zendeskwidgettoken, value);
    }

    public getZendeskSSOToken(): string {
        return localStorage.getItem(Constants.Storage.zendeskssotoken) || '';
    }

    public setZendeskSSOToken(value: string) {
        value = value !== undefined ? value : '';
        localStorage.setItem(Constants.Storage.zendeskssotoken, value);
    }
    
    public getFileData(): string {
        return localStorage.getItem(Constants.Storage.fileData) || '';
    }

    public setFileData(value: string) {
        value = value !== undefined ? value : '';
        localStorage.setItem(Constants.Storage.fileData, value);
    }

    public clearFileData() {
        return localStorage.removeItem(Constants.Storage.fileData);
    }

    public getReportData(): string {
        return localStorage.getItem(Constants.Storage.reportData) || '';
    }
    
    public clearAll() {
        let uname = this.getUsername();
        localStorage.clear();
        this.setUsername(uname);
    }
}


// WEBPACK FOOTER //
// ./src/service/localstorage.ts